<template>
  <button
    v-if="!href"
    :class="`btn ${theme}`"
    :type="type"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot></slot>
  </button>
  <a
    v-else
    :class="`btn ${theme}`"
    :disabled="disabled"
    :href="href"
    target="_blank"
    @click="$emit('click')"
  >
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'button'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'cta'
    },
    href: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  @include font('secondary', 'regular');
  @include padding(11px 17px 9px);
  display: inline-block;
  border: 1px solid $primary;
  border-radius: 5px;
  outline: none;
  background-color: $primary;
  color: $white;
  font-size: rem(16px);
  line-height: 1;
  text-align: center;

  &[disabled] {
    opacity: .3;
  }

  .svg {
    @include margin(-4px null null 4px);
    display: inline-block;
    fill: $white;
    vertical-align: middle;

    &:first-child {
      @include margin(null 4px null 0);
    }
  }

  &.dark {
    @include padding(null 14px);
    background-color: $black-light;
    border-color: $black-light;
    color: $white;

    &[disabled] {
      opacity: 1;
      color: rgba($white, .5);
    }

    .svg {
      fill: $white;
    }
  }

  &.ghost {
    @include padding(null 14px);
    background-color: rgba($white, 0);
    color: $primary;

    .svg {
      fill: $primary;
    }
  }

  &.transparent {
    @include padding(null 14px);
    background-color: rgba($white, 0);
    border-color: rgba($white, 0);
    color: $primary;

    .svg {
      fill: $primary;
    }
  }

  &.bordered {
    border-color: $white;
  }
}
</style>
